import EntityService from "./entity";

class ExhibitorService extends EntityService {
  constructor(name) {
    super(name)
  }
}

export default new ExhibitorService("exhibitor")



// WEBPACK FOOTER //
// ./src/services/exhibitor.js